<template>
    <v-dialog v-model="dialog" persistent max-width="390">
      <template v-slot:activator="{ on }">
        <v-btn class="ma-0" flat v-on="on">
          <v-icon color="red darken-2"
          >
            delete
          </v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title class="headline">Bestätigung</v-card-title>
        <v-card-text>Möchten Sie die Daten wirklich löschen?</v-card-text>
        <v-card-actions>
          <v-btn color="green darken-1" flat @click="dialog = false">
            Nein</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click="_deleteItem_">
            Ja</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios'
  export default {
    props: ['id', 'backendRoute'],
    data () {
      return {
        dialog: false
      }
    },
    methods: {
      _deleteItem_(){
        axios.post(`${this.backendRoute}.php?id=` + this.id)
        .then(response => {
          if (response.data.success) {
            this.dialog = false
            this.$emit('itemDeleted')
          }
        })
      }
    }
  }
</script>
